module.exports = __webpack_public_path__ + "img/edit-color.4a390bb5.svg";